import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetCanalAtencion } from '../shared/interfaces/configuracion';
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class CanalAtencionService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private readonly http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/canal-atencion`;
  }

  getCanalesAtencions(): Observable<IGetCanalAtencion[]> {
    return this.http.get<IGetCanalAtencion[]>(`${this.baseUrl}`);
  }
}
